import Service from "../service";
import AuthService from "../AuthService";

const MedicalTool = {
  saveDataTools(data) {
    let formData = new FormData();
    formData.append('spec_no',data.spec_no);
    formData.append('spec_code',data.spec_code);
    formData.append('name_th',data.name_th);
    formData.append('name_en',data.name_en);
    formData.append('unit',data.unit);
    formData.append('year',data.year);
    formData.append('comm_id',data.comm_id);
    formData.append('path_file',data.path_file);
    formData.append('type_spec',data.type_spec);
    formData.append('status',data.status);
    formData.append('pass_no',data.pass_no);
    formData.append('dep_name',data.dep_name);
    formData.append('group_num',data.group_num);
    formData.append('gpsc',data.gpsc);
    formData.append('workername',data.workername);
    formData.append('keyword',data.keyword);
    formData.append('_method', 'POST');
    return AuthService.post('/api/med', formData,{
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    });
  },
  getAllDataTool(page) {
    return AuthService.get('/api/get-meds-all?page='+page)
  },
  getAllDataToolForExport() {
    return AuthService.get('/api/get-meds-all-export')
  },
  getAllMeds(page) {
    return AuthService.get('/api/get-all-med?page='+page)
  },
  getDataToolEdit(id) {
    return AuthService.get(`/api/med/${id}`)
  },
  editDataTool(id,data) {
    let formData = new FormData();
    formData.append('spec_no',data.spec_no || '' );
    formData.append('spec_code',data.spec_code || '' );
    formData.append('name_th',data.name_th) || '' ;
    formData.append('name_en',data.name_en || '' );
    formData.append('unit',data.unit || '' );
    formData.append('year',data.year || '' );
    formData.append('comm_id',data.comm_id || '' );
    formData.append('path_file',data.path_file || '' );
    formData.append('type_spec',data.type_spec || '' );
    formData.append('status',data.status || '' );
    formData.append('pass_no',data.pass_no || '' );
    formData.append('dep_name',data.dep_name || '' );
    formData.append('group_num',data.group_num || '' );
    formData.append('main_group',data.main_group || '' );
    formData.append('sub_group',data.sub_group || '' );
    formData.append('gpsc',data.gpsc || '' );
    formData.append('workername',data.workername || '' );
    formData.append('keyword',data.keyword || '' );
    formData.append('_method', 'POST');
    return AuthService.post(`/api/edit-med/${id}`, formData, {
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    })
  },
  deleteDataTool(id) {
    return AuthService.delete(`/api/med/${id}`)
  },
  getSpecGroup() {
    // return AuthService.get('/api/med-group')
    return AuthService.get('/api/get-spec-group')
  },
  getSubGroup(id) {
    return AuthService.get(`/api/get-sub-group/${id}`)
  },
  searchMed(data) {
    if(!data.main_group) {
      data.main_group = '';
    }
    if(!data.spec_no) {
      data.spec_no = '';
    }
    if(!data.sub_group) {
      data.sub_group = '';
    }
    // return AuthService.get('/api/med?page='+data.page+'&main_group='+data.main_group+'&spec_no='+data.spec_no+'&sub_group='+data.sub_group)
    return AuthService.get('/api/get-meds-all?page='+data.page+'&main_group='+data.main_group+'&spec_no='+data.spec_no+'&sub_group='+data.sub_group)
  },
  importDataToolsExcel(data) {
    let formData = new FormData();
    formData.append('import_file',data.import_file);
    return AuthService.post('/api/import-excel', formData,{
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    })
  },
  importDataToolsPDF(data) {
    return AuthService.post('/api/import-pdf', data,{
      headers: {
        "Content-Type": 'multipart/form-data',
      }
    })
  },
  getOrder(id) {
    return AuthService.get(`/api/med/${id}`)
  },
  updateStatusNotPrint(data) {
    return AuthService.post('/api/update-status-not-print', data)
  }

};

export default MedicalTool;
